import { Injectable } from '@angular/core';
import { State, Action, Selector, StateContext } from '@ngxs/store';
import { catchError, delay, map, tap } from 'rxjs/operators';
import { Observable, of } from 'rxjs';
import { ROOT_ENV } from '../../../../../services/config/config.service';
import { NotificationService } from '../../../../../common/services';
import { NewsletterUnsubscribeConfirmation } from './newsletter-unsubscribe.actions';
import { NewsletterUnsubscribeService } from './newsletter-unsubscribe.service';
import { Error, CustomHttpErrorResponse } from '../../../../../common/constants/error';
import { REDIRECTION_BASIC_DELAY } from '../../../../../common/constants/delays';
import { MatSnackBarRef, SimpleSnackBar } from '@angular/material/snack-bar';

export interface NewsletterUnsubscribeStateModel {
  loaded: boolean;
}

const initialState: NewsletterUnsubscribeStateModel = {
  loaded: false,
};

@State<NewsletterUnsubscribeStateModel>({
  name: 'newsletterUnsubscribe',
  defaults: initialState,
})
@Injectable()
export class NewsletterUnsubscribeState {
  @Selector()
  static getState(state: NewsletterUnsubscribeStateModel): NewsletterUnsubscribeStateModel {
    return state;
  }

  @Selector()
  static getLoaded(state: NewsletterUnsubscribeStateModel): boolean {
    return state.loaded;
  }

  constructor(
    private newsletterService: NewsletterUnsubscribeService,
    private notificationService: NotificationService,
  ) {}

  @Action(NewsletterUnsubscribeConfirmation)
  confirmNewsletterSubscription(
    ctx: StateContext<NewsletterUnsubscribeStateModel>,
    { payload }: NewsletterUnsubscribeConfirmation,
  ): Observable<MatSnackBarRef<SimpleSnackBar> | void> {
    return this.newsletterService.confirmNewsletterUnsubscribe(payload).pipe(
      map(() => {
        ctx.patchState({ loaded: true });
      }),
      catchError(({ error }: CustomHttpErrorResponse<Error>) => {
        return of(this.notificationService.error(error.message)).pipe(
          delay(REDIRECTION_BASIC_DELAY),
          tap(() => window.open(ROOT_ENV, '_self')),
        );
      }),
    );
  }
}
